export default __webpack_public_path__ + "static/media/plus.e5bcfdf2.svg";